// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: "bcn-taxi-quiz.firebaseapp.com",
  projectId: "bcn-taxi-quiz",
  storageBucket: "bcn-taxi-quiz.appspot.com",
  messagingSenderId: "242469064574",
  appId: "1:242469064574:web:58e51544daac211266ed2f",
  measurementId: "G-F6EJSQNG8H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const firestore = getFirestore(app)